export { default as add } from './modules/add'
export { default as addIndex } from './modules/addIndex'
export { default as adjust } from './modules/adjust'
export { default as all } from './modules/all'
export { default as allPass } from './modules/allPass'
export { default as anyPass } from './modules/anyPass'
export const always = x => () => x
export { default as any } from './modules/any'
export { default as append } from './modules/append'
export { default as both } from './modules/both'
export const complement = fn => input => !fn(input)
export { default as compose } from './modules/compose'
export { default as concat } from './modules/concat'
export { default as contains } from './modules/contains'
export { default as curry } from './modules/curry'
export { default as dec } from './modules/dec'
export { default as defaultTo } from './modules/defaultTo'
export { default as divide } from './modules/divide'
export { default as drop } from './modules/drop'
export { default as dropLast } from './modules/dropLast'
export { default as either } from './modules/either'
export { default as endsWith } from './modules/endsWith'
export { default as inc } from './modules/inc'
export { default as equals } from './modules/equals'
export const F = () => false
export { default as filter } from './modules/filter'
export { default as find } from './modules/find'
export { default as findIndex } from './modules/findIndex'
export { default as flatten } from './modules/flatten'
export { default as flip } from './modules/flip'
export { default as forEach } from './modules/forEach'
export { default as has } from './modules/has'
export { default as head } from './modules/head'
export const identity = x => x
export { default as ifElse } from './modules/ifElse'
export { default as is } from './modules/is'
export { default as isNil } from './modules/isNil'
export { default as includes } from './modules/includes'
export { default as indexOf } from './modules/indexOf'
export { default as init } from './modules/init'
export { default as join } from './modules/join'
export { default as lastIndexOf } from './modules/lastIndexOf'
export { default as last } from './modules/last'
export { default as length } from './modules/length'
export { default as map } from './modules/map'
export { default as match } from './modules/match'
export { default as merge } from './modules/merge'
export { default as modulo } from './modules/modulo'
export { default as multiply } from './modules/multiply'
export { default as none } from './modules/none'
export const not = x => !x
export { default as omit } from './modules/omit'
export { default as partialCurry } from './modules/partialCurry'
export { default as path } from './modules/path'
export { default as pathOr } from './modules/pathOr'
export { default as pick } from './modules/pick'
export { default as pickAll } from './modules/pickAll'
export { default as pipe } from './modules/pipe'
export { default as pluck } from './modules/pluck'
export { default as prepend } from './modules/prepend'
export { default as prop } from './modules/prop'
export { default as propEq } from './modules/propEq'
export { default as range } from './modules/range'
export { default as reduce } from './modules/reduce'
export { default as reject } from './modules/reject'
export { default as repeat } from './modules/repeat'
export { default as replace } from './modules/replace'
export { default as reverse } from './modules/reverse'
export { default as sort } from './modules/sort'
export { default as sortBy } from './modules/sortBy'
export { default as split } from './modules/split'
export { default as splitEvery } from './modules/splitEvery'
export { default as startsWith } from './modules/startsWith'
export { default as subtract } from './modules/subtract'
export const T = () => true
export { default as tap } from './modules/tap'
export { default as tail } from './modules/tail'
export { default as take } from './modules/take'
export { default as takeLast } from './modules/takeLast'
export { default as test } from './modules/test'
export { default as times } from './modules/times'
export { default as toLower } from './modules/toLower'
export { default as toUpper } from './modules/toUpper'
export { default as toString } from './modules/toString'
export const trim = x => x.trim()
export { default as type } from './modules/type'
export { default as uniq } from './modules/uniq'
export { default as uniqWith } from './modules/uniqWith'
export { default as update } from './modules/update'
export { default as values } from './modules/values'
export { default as without } from './modules/without'
